__turbopack_context__.v({
  "stockUrgency": "stock-urgency-module__jHmilG__stockUrgency",
  "stockUrgencyDot": "stock-urgency-module__jHmilG__stockUrgencyDot",
  "stockUrgencyPulse": "stock-urgency-module__jHmilG__stockUrgencyPulse",
});
